import { render } from "./ImageModal.vue?vue&type=template&id=11532749&scoped=true&ts=true"
import script from "./ImageModal.vue?vue&type=script&lang=ts"
export * from "./ImageModal.vue?vue&type=script&lang=ts"

import "./ImageModal.vue?vue&type=style&index=0&id=11532749&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11532749"]])

export default __exports__